var CompareAndUpdateCandidateDetailsController = /** @class */ (function () {
    function CompareAndUpdateCandidateDetailsController() {
    }
    CompareAndUpdateCandidateDetailsController.prototype.$onInit = function () {
        this._setFields();
    };
    CompareAndUpdateCandidateDetailsController.prototype._setFields = function () {
        angular.forEach(this.candidateConflictDetails.candidateConflictDetails, function (conflict, key) {
            conflict.fieldId = conflict.fieldName.split(" ").join("-");
            conflict.selectedValue = conflict.newValue;
            conflict.newValueSelected = true;
        });
    };
    CompareAndUpdateCandidateDetailsController.prototype.updateField = function (index, flag) {
        if (flag) {
            this.candidateConflictDetails.candidateConflictDetails[index].selectedValue = this.candidateConflictDetails.candidateConflictDetails[index].newValue;
        }
        else {
            this.candidateConflictDetails.candidateConflictDetails[index].selectedValue = this.candidateConflictDetails.candidateConflictDetails[index].oldValue;
        }
    };
    CompareAndUpdateCandidateDetailsController.prototype.save = function () {
        var contactDetails = {
            firstName: this.candidateConflictDetails.candidateConflictDetails[0].selectedValue,
            lastName: this.candidateConflictDetails.candidateConflictDetails[1].selectedValue,
            email: this.candidateConflictDetails.candidateConflictDetails[2].selectedValue,
            phoneNumber: this.candidateConflictDetails.candidateConflictDetails[3].selectedValue
        };
        this.saveCallback({ contactDetails: contactDetails });
    };
    CompareAndUpdateCandidateDetailsController.prototype.cancel = function () {
        if (this.candidateConflictDetails && this.candidateConflictDetails.candidateConflictDetails.length > 0) {
            var contactDetails = {
                firstName: this.candidateConflictDetails.candidateConflictDetails[0].selectedValue,
                lastName: this.candidateConflictDetails.candidateConflictDetails[1].selectedValue,
                email: this.candidateConflictDetails.candidateConflictDetails[2].selectedValue,
                phoneNumber: this.candidateConflictDetails.candidateConflictDetails[3].selectedValue
            };
            this.cancelCallback({ contactDetails: contactDetails });
        }
        else {
            this.cancelCallback(null);
        }
    };
    return CompareAndUpdateCandidateDetailsController;
}());
// import * as TEMPLATE from './compare-and-update-candidate-details.html';
import * as TEMPLATE from 'raw-loader!./compare-and-update-candidate-details.html';
export var CompareAndUpdateCandidateDetailsComponent = {
    selector: 'compareAndUpdateCandidateDetails',
    component: {
        bindings: {
            candidateConflictDetails: '=',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: CompareAndUpdateCandidateDetailsController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addCandidates/addCandidates/uploadResumes/compareAndUpdateCandidateDetails/compare-and-update-candidate-details.html'
    }
};
//# sourceMappingURL=compare-and-update-candidate-details.component.js.map